import { render, staticRenderFns } from "./SaleInvoiceCollectList.vue?vue&type=template&id=3c10f03f&scoped=true&"
import script from "./SaleInvoiceCollectList.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceCollectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10f03f",
  null
  
)

export default component.exports